/// <amd-module name="SuiteCommerce.Blog.DataProviderEntities.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProviderEntities.Model", ["require", "exports", "SuiteCommerce.Blog.DataProvider.Category.Collection", "SuiteCommerce.Blog.DataProvider.Author.Collection", "SuiteCommerce.Blog.DataProvider.Term.Collection", "Backbone", "Utils"], function (require, exports, DataProvider_Category_Collection_1, DataProvider_Author_Collection_1, DataProvider_Term_Collection_1, Backbone_1, Utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DataProviderModel = void 0;
    var DataProviderModel = /** @class */ (function (_super) {
        __extends(DataProviderModel, _super);
        function DataProviderModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.urlRoot = Utils.getAbsoluteUrl(getExtensionAssetsPath("assets/services/BlogEntitiesSearch.Service.ss"), true);
            return _this;
        }
        Object.defineProperty(DataProviderModel.prototype, "categories", {
            get: function () {
                var categoryCollection = new DataProvider_Category_Collection_1.CategoryCollection();
                categoryCollection.add(this.get('categories'));
                return categoryCollection;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DataProviderModel.prototype, "authors", {
            get: function () {
                var authorCollection = new DataProvider_Author_Collection_1.AuthorCollection();
                authorCollection.add(this.get('authors'));
                return authorCollection;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DataProviderModel.prototype, "terms", {
            get: function () {
                var termCollection = new DataProvider_Term_Collection_1.TermCollection();
                termCollection.add(this.get('terms'));
                return termCollection;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DataProviderModel.prototype, "isSync", {
            get: function () {
                return this.get('isSync');
            },
            set: function (isSync) {
                this.set('isSync', isSync);
            },
            enumerable: false,
            configurable: true
        });
        return DataProviderModel;
    }(Backbone_1.Model));
    exports.DataProviderModel = DataProviderModel;
});
